import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  AiBuilderCreatePageComponent
} from "../../../../../../websites/website/ai-builder/dialogs/ai-builder-create-page/ai-builder-create-page.component";
import {DbModalService} from "../../../../../../modules/modal/modal";
import {Website} from "../../../../../../websites/website/website";
import {Product} from "../../../../../../websites/website/product";
import {User} from "../../../../../../user/user";

@Component({
    selector: 'db-create-ai-assistant-start-view',
    templateUrl: './create-ai-assistant-start-view.component.html',
    styleUrls: ['./create-ai-assistant-start-view.component.scss'],
    standalone: false
})
export class CreateAiAssistantStartViewComponent {
  @Input() isOnboarding = false;
  @Input() showThemeNotification = false;
  @Input() themeIsActive = false;
  @Input() loading = false;
  @Input() user: User;
  @Input() website: Website;
  @Input() builderPlugin: Product;
  @Input() elementorPlugin: Product;
  @Output() start = new EventEmitter<void>();
  @Output() activateTheme = new EventEmitter<void>();

  constructor(
    private _modalService: DbModalService
  ) {}

  public createPageDialog(): void {
    const modal = this._modalService.open(AiBuilderCreatePageComponent, {height: 600, width: 940, whiteCloseBtn: (window.innerWidth > 991)});
    modal.componentInstance.website = this.website;
    modal.componentInstance.trialUser = this.user.starterClient;
    modal.componentInstance.userEmail = this.user.email;
    modal.componentInstance.kitData = null;
    modal.componentInstance.choosedStep = 'builder';
    modal.componentInstance.hideBackButton = true;
    modal.componentInstance.hasFrontPage = false;
    modal.componentInstance.builderPlugin = this.builderPlugin;
    modal.componentInstance.elementorPlugin = this.elementorPlugin;
  }
}
